/* ============================================================================
   BLANK CARD × WORKFLOW — peraturan berasingan · 3 Nov 2026
   ============================================================================
   Arahan user 3 Nov: "blank card boleh pakai utk semua jenis workflow dulu, nnti aku filter kemudian
   apa workflow yg x sesuai utk blank card tu. (yg ini agent lain tgh buat. so buat separate)".

   ⭐ Fail ini SATU-SATUNYA tempat menapis workflow untuk blank card (`kosong: true`, moduleId 'blank').
      Untuk menapis: buang id robot daripada senarai yang dipulangkan. Tiada fail lain perlu diubah.
   ⚠️ Keadaan LARIAN hari ini (dibaca dari kod, 3 Nov): blank card berjalan atas robot AI8SAAT
      (getModule('blank') jatuh ke lalai ai8saat). Jadi hanya 'ai8saat' + 'ai8saat-kad' benar-benar
      mengubah larian; pilihan lain untuk blank card belum disambung ke Run — dropdown memaparkan
      amaran itu (BLANK_SUDAH_JALAN di bawah). Bila laluan Run blank card siap, kemas kini senarai itu.
   ========================================================================== */

/* Semua robot dalam utils/workflowRobot.js ROBOT_WF (KEMBAR senarai id — tambah di sana, tambah di sini). */
const SEMUA_ROBOT = [
    'ai8saat', 'ai8saat-kad', 'ai16saat', 'goyang', 'nscene',
    'resipi-sama', 'resipi-berlainan', 'resipi-tiada', 'resipi-frame', 'resipi-sahaja',
];

/** Robot yang dipapar dalam dropdown bila card yang ditick ialah blank card. */
export function robotUntukBlankCard() {
    return [...SEMUA_ROBOT];
}

/** Robot yang Run blank card BENAR-BENAR ikut hari ini. Yang lain = amaran "belum disambung". */
export const BLANK_SUDAH_JALAN = ['ai8saat', 'ai8saat-kad'];
